module.exports = "https://static.wagwalking.com/_next/static/images/pet-4-6a6aff4693397d37b368fd4d148f5354.png";